import { useState, } from 'react';

import { Table, } from 'react-bootstrap';
import { TableContainer, Container, TablePagination, Paper, } from '@material-ui/core';

import styles from './styles.module.scss';


function TicketsPerTypeTable({ items, }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);


  function onChangePage (event, newPage) {
    setPage(newPage);
  }

  function onChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }


  return (
    <TableContainer
      component={Paper}
      elevation={2}
      disableGutters
    >
      <Container
        className={styles.StyleTable}
        maxWidth="xl"
      >
        <Table
          className={styles.tableLeft}
          responsive
        >
          <thead>
            <tr>
              <th className={styles.titleLeft}>
                Categoria mais acessada
              </th>

              <th className={styles.titleRight}>
                Quantidade de requisições
              </th>
            </tr>
          </thead>

          <tbody>
            {
              items
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((data, index) => {
                  return (
                    <tr key={index} >
                      <td
                        style={{
                          fontFamily: 'Inter, sans-serif !important',
                          fontWeight: '500 !important',
                          fontSize: '15px !important',
                          color: '#1c265a !important',
                        }}
                      >
                        {data.tipo_chamado}
                      </td>

                      <td
                        style={{
                          textAlign: 'right',
                          fontFamily: 'Inter, sans-serif !important',
                          fontWeight: '500 !important',
                          fontSize: '16px !important',
                          color: '#1c265a !important',
                        }}
                      >
                        {data.type}
                      </td>
                    </tr>
                  );
                })
            }
          </tbody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={items.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
      </Container>
    </TableContainer>
  );
}

export default TicketsPerTypeTable;
